import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { StoreInquireService } from 'src/app/services/store-inquire.service';
import { TitlePagesService } from 'src/app/services/title-pages.service';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { CompanyService } from 'src/app/services/company/company.service';
import { Company } from 'src/app/models/company';
import { GalavailServiceEcommer } from "clientwsGalavail";

@Component({
  selector: 'app-thanks-onhold',
  templateUrl: './thanks-onhold.component.html',
  styleUrls: ['./thanks-onhold.component.css']
})
export class ThanksOnholdComponent implements OnInit {


  public subscription: Subscription;

  public empresa: string;
  public nombreEmpresa: string;
  public nameLogo: string;
  public colorPrimario: string;
  public colorSecundario: string;
  public colorCabecera: string;
  public colorPie: string;

  public dias: string;
  public barco: string;
  public promocion: string;
  public fechaArrivo: string;
  public fechaSalida: string;
  public duracion: string;
  public opcDuracion: string;
  public textDuracion: string;

  public todayDate: number = new Date().getFullYear();

  public URLMonth = '';
  public URLYear = '';
  public URLDateRange='';

  // Variables para titulos de datos recptados
  public textDaysCruise: string;
  public textItinerary: string;
  public textStarEndDay: string;
  public mailTo: string;

  public keyCompany: string;

  public textPromo: string;
  public dataCompany: Company;
  public multiDepartures: any[] = [];
  public isMultiOnHold = false;
  companyLogo = environment.appResource.companyLogos;
  logoCruise = environment.appResource.logoCruise;
  constructor(
    private activatedRoute: ActivatedRoute,
    public title: TitlePagesService,
    public storeLocalInquireService: StoreInquireService,
    @Inject(DOCUMENT) private document: Document,
    private companyService: CompanyService,
    private router: Router,
    private renderer2: Renderer2,
    private galavailServiceEcommer: GalavailServiceEcommer,

  ) {
    this.subscription = this.activatedRoute.params.subscribe(params => {
      this.empresa = params['company'];
      this.keyCompany = params['code'];

      this.storeLocalInquireService.getLocalStorages(this.keyCompany);
    });
    this.title.changeTitlePage(this.storeLocalInquireService.getBoat(), 'thanks');
  }

  ngOnInit() {
    // =============================
    // Load 279387 Sojern Tag v6_js, Pixel Version: 1
    this.dataCompany = this.companyService.getCompanyParams();
    if (isNullOrUndefined(this.dataCompany)) {
      this.goBack();
    }
    const srcScript = this.renderer2.createElement('script');
    srcScript.type = 'text/javascript';
    srcScript.text = `
      (function () {
        console.log('>>>>> Load Script 279387');
        /* Please fill the following values. */
        var params = {
          vd1: "", /* Departure Date */
          vd2: "", /* Return Date */
          vf1: "", /* Destination City */
          vs1: "", /* Destination State or Region */
          vn1: "", /* Destination Country */
          vb: "", /* Attraction Name */
          t: "", /* Number of Travelers */
          vp: "", /* Purchase Price */
          vcu: "", /* Purchase Currency */
          vconfno: "" /* Confirmation Number */
        };

        /* Please do not modify the below code. */
        var cid = [];
        var paramsArr = [];
        var cidParams = [];
        var pl = document.createElement('script');
        var defaultParams = {"vid":"tou","et":"vc"};
        for(key in defaultParams) { params[key] = defaultParams[key]; };
        for(key in cidParams) { cid.push(params[cidParams[key]]); };
        params.cid = cid.join('|');
        for(key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };
        pl.type = 'text/javascript';
        pl.async = true;
        pl.src = 'https://beacon.sojern.com/pixel/p/279387?f_v=v6_js&p_v=1&' + paramsArr.join('&');
        (document.getElementsByTagName('head')[0] ||
          document.getElementsByTagName('body')[0]).appendChild(pl);
      })();
    `;
    this.renderer2.appendChild(this.document.body, srcScript);
    // =============================
    const tempDuracion = this.storeLocalInquireService.getLength().substr(0, 1);
    // const tempItinerary = this.opcDuracion.substr(1, 1);
    const tempItinerary = this.storeLocalInquireService.getNameIti().substr(1, 1);
    // this.textDaysCruise = tempDuracion + '-day';
    this.textDaysCruise = this.storeLocalInquireService.getLength();
    this.textItinerary = this.textDaysCruise + ' ' + tempItinerary;
    // this.textStarEndDay = this.diaDiaCrucero + ' (' + tempItinerary + ')';
    this.textStarEndDay = this.storeLocalInquireService.getStartEndDates() + ' (' + tempItinerary + ')';
    this.mailTo = this.storeLocalInquireService.getInfoMail();
    if (this.storeLocalInquireService.getPromotion().length == 10 || this.storeLocalInquireService.getPromotion().length == 0) {
      this.textPromo = 'none';
    } else {
      this.textPromo = this.storeLocalInquireService.getPromotion();
    }

    this.manageURLMonthYear();

    const multiResult = this.galavailServiceEcommer.getDataofLocalStorage(
      "dataInquireMultiResult-" + this.keyCompany
    );
    this.multiDepartures =
      multiResult && Array.isArray(multiResult) && multiResult.length >= 2
        ? multiResult
        : [];
    this.isMultiOnHold = this.multiDepartures.length >= 2;

  }

  getTotalMultiAdults(): number {
    return this.multiDepartures.reduce((acc, d) => acc + Number(d.adults || 0), 0);
  }

  getTotalMultiChildren(): number {
    return this.multiDepartures.reduce((acc, d) => acc + Number(d.children || 0), 0);
  }

  getMultiTotalPassengers(): number {
    return this.getTotalMultiAdults() + this.getTotalMultiChildren();
  }

  public manageURLMonthYear() {
    const companyDateRange = this.companyService.getDateRange();
    if (companyDateRange && companyDateRange.length != 0) {
      this.URLDateRange = companyDateRange;
      return;
    }
    const storedDateRange = this.galavailServiceEcommer.getDataofLocalStorage('daterange');
    if (storedDateRange) {
      this.URLDateRange = storedDateRange;
      return;
    }
    try {
      const dataInquire = this.galavailServiceEcommer.getDataofLocalStorage('dataInquire-' + this.keyCompany);
      const startDate = new Date(Date.parse(dataInquire.startDate));
      if (!isNaN(startDate.getTime())) {
        const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
        this.URLDateRange = this.formatDate(startDate) + '-' + this.formatDate(endDate);
        return;
      }
    } catch (error) {
      console.error(error);
    }
    this.URLDateRange = 'All-All';
  };

  /**
   * Metodo que no ayuda a verificar si el color del pie es claro u oscuro,
   * esto se lo aplica para dar cierto estilos en el div
   * @param hexcolor
   */
  isTooDark(hexcolor: any) {
    if (hexcolor != null) {
      const r = parseInt(hexcolor.substr(1, 2), 16);
      const g = parseInt(hexcolor.substr(3, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      // Return new color if to dark, else return the original
      // return (yiq < 40) ? '#2980b9' : hexcolor;
      return (yiq < 150);
    } else {
      return false;
    }

  }
  goBack() {
    if (!this.URLDateRange) {
      this.manageURLMonthYear();
    }
    this.router.navigate([
      `${this.empresa}/All/All/${this.URLDateRange}/1`,
    ]);
  }

  formatDate(date: Date): string {
    let dayString = date.getDate() < 10 ? '0' : '';
    let monthString = date.getMonth() < 9 ? '0' : '';
    let dateString: string = dayString + date.getDate().toString() + monthString + (date.getMonth() + 1).toString() + date.getFullYear().toString();
    return dateString;
  }

}
